// Imports
import { Tiles } from 'src/modules/content-tiles/jsx/tiles.jsx';
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";


// Stateless components

export function SupportPage(props) {

    //
    // Render
    //

    return (
        <>
            <ContextualMessage id="support" />
            <div className="page-inner__content">
                <Tiles columns="mixed" background="dark" />
            </div>
        </>
    );
};
